// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"287":"93bc0ba4","818":"ccdc9432","1657":"78ccb678","4078":"c481ccaa","4884":"93bc0ba4","6351":"35a74d46","9862":"27a18031"}[chunkId] + ".chunk.css";
};